export default "__VITE_ASSET__CMvnwlYb__"